/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Notice_Seller_PrivacyInputs */

const en_seller_notice_seller_privacy = /** @type {(inputs: Seller_Notice_Seller_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller's privacy policy`)
};

const pl_seller_notice_seller_privacy = /** @type {(inputs: Seller_Notice_Seller_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka prywatności sprzedawcy`)
};

/**
* | output |
* | --- |
* | "Seller's privacy policy" |
*
* @param {Seller_Notice_Seller_PrivacyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_seller_privacy = /** @type {((inputs?: Seller_Notice_Seller_PrivacyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_Seller_PrivacyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_seller_privacy(inputs)
	return en_seller_notice_seller_privacy(inputs)
});